/**
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

/**
Toolstrip Column Widget sets the children width to be 100%.
Size Mixin does not allow 100% as a value.
**/

define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {
        _allowedValues: ["auto", "100%"],
        //Overriding size mixin to handle 100%
        _validateSizeInput: function (value) {
            if (value !== "100%") {
                this.inherited(arguments);
            }
        },
        //Overriding size mixin to handle 100%
        _setSize: function (sizeType, value) {
            this._validateSizeInput(value);

            this._set(sizeType, value);

            // Do not attempt DOM sizing during the widget construction phase
            if (!this._started) {
                return;
            }

            if(value==="100%") {
                if(this.getParent()) {
                    value = this.getParent().get("width");
                }
            }
            var valueForDom = "";
            if (this._allowedValues.indexOf(value) >= 0) {
                valueForDom = value;
            } else {
                valueForDom = this._getAdjustedSize(sizeType, value, this.domNode);
            }

            this.domNode.style[sizeType] = valueForDom;
        }
    });
});
